<!--
 * @Auther: 罗耀祖
 * @Date: 2022-03-04 16:17:47
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-08-09 11:39:37
 * @name: 确认上门
 * @Description: 确认上门
 * @FilePath: \project\src\views\index\afterSale\waitDealToDoorService\waitDealToDoorService.vue
 * @Author: desktop
-->
<template>
  <div class="waitDealToDoorService">
    <div class="container">
      <div class="head">
        <el-button size="mini" type="primary" @click="back">返回</el-button>
      </div>
      <div class="content">
        <div class="left">
          <div class="card">
            <div class="title">
              <font>用户信息</font>
            </div>
            <div class="user-info">
              <div class="row">
                <font class="label">琴行名称：</font>
                <font class="value">{{ agency.agency_name }}</font>
              </div>
              <div class="row">
                <font class="label">琴行地址：</font>
                <font class="value">{{ agency.address }}</font>
              </div>
              <div class="row">
                <font class="label">联系电话：</font>
                <font class="value">{{ agency.mobile }}</font>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="title">
              <font>问题信息</font>
            </div>
            <div class="problem-info">
              <div class="piano" v-if="piano_model || piano_no || piano_color">
                <div class="col" v-if="piano_model">
                  <font>型号：</font>
                  <font>{{ piano_model }}</font>
                </div>
                <div class="col" v-if="piano_no">
                  <font>琴号：</font>
                  <font>{{ piano_no }}</font>
                </div>
                <div class="col" v-if="piano_color">
                  <font>颜色：</font>
                  <font>{{ piano_color }}</font>
                </div>
              </div>
              <div class="piano_images" v-if="piano_images.length > 0">
                <font>图片: </font>
                <div class="piano_images_group">
                  <div
                    class="img-box"
                    v-for="(item, index) of piano_images"
                    :key="item + index"
                  >
                    <img :src="item" />
                    <div
                      class="floating"
                      @click="showPreview(piano_images, index)"
                    >
                      <img src="@/assets/icon/eye.png" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="package_images" v-if="package_images.length > 0">
                <font>破损外包装图: </font>
                <div class="package_images_group">
                  <div
                    class="img-box"
                    v-for="(item, index) of package_images"
                    :key="item + index"
                  >
                    <img :src="item" />
                    <div
                      class="floating"
                      @click="showPreview(package_images, index)"
                    >
                      <img src="@/assets/icon/eye.png" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="express_images" v-if="express_images.length > 0">
                <font>物流单据图: </font>
                <div class="express_images_group">
                  <div
                    class="img-box"
                    v-for="(item, index) of express_images"
                    :key="item + index"
                  >
                    <img :src="item" />
                    <div
                      class="floating"
                      @click="showPreview(express_images, index)"
                    >
                      <img src="@/assets/icon/eye.png" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="problem-detail" v-if="!(musical === '其它')">
                <font class="problem-label">问题部位：</font>
                <div class="problem-content">
                  <div
                    class="problem-part"
                    v-for="itemX of positions"
                    :key="itemX.key"
                  >
                    <div class="problem-name">
                      <font>{{ itemX.name }}</font>
                    </div>
                    <div class="problem-questions">
                      <div
                        class="questions-item"
                        v-for="(itemY, indexY) of itemX.questions"
                        :key="itemY.key"
                      >
                        <div class="questions-head">
                          <div class="questions-name">
                            <font class="label">{{ indexY + 1 }}、</font>
                            <font class="text">{{ itemY.name }}</font>
                          </div>
                          <div class="questions-desc">
                            <font class="label">问题描述：</font>
                            <font class="text">{{ itemY.desc }}</font>
                          </div>
                        </div>
                        <div class="questions-images">
                          <div
                            class="img-box"
                            v-for="(itemZ, indexZ) of itemY.files.split(',')"
                            :key="itemZ + indexZ"
                          >
                            <template v-if="itemZ.indexOf('video') > -1">
                              <div class="video-box">
                                <img
                                  :src="
                                    itemZ +
                                    '?x-oss-process=video/snapshot,t_0,f_jpg'
                                  "
                                  class="video"
                                />
                              </div>
                              <div
                                class="floating"
                                @click="
                                  showPreview(itemY.files.split(','), indexZ)
                                "
                              >
                                <img src="@/assets/icon/video-start.png" />
                              </div>
                            </template>
                            <template v-else>
                              <img :src="itemZ" class="image" />
                              <div
                                class="floating"
                                @click="
                                  showPreview(itemY.files.split(','), indexZ)
                                "
                              >
                                <img src="@/assets/icon/eye.png" />
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="other_question_des" v-if="other_question_des">
                <font>问题描述: </font>
                <div class="span">
                  <span>{{ other_question_des }}</span>
                </div>
              </div>
              <div
                class="other_question_urls"
                v-if="other_question_urls.length > 0"
              >
                <font>问题图片/视频: </font>
                <div class="other_question_urls_group">
                  <div
                    class="img-box"
                    v-for="(item, index) of other_question_urls"
                    :key="item + index"
                  >
                    <template v-if="item.indexOf('video') > -1">
                      <div class="video-box">
                        <img
                          :src="
                            item + '?x-oss-process=video/snapshot,t_0,f_jpg'
                          "
                          class="video"
                        />
                      </div>
                      <div
                        class="floating"
                        @click="showPreview(other_question_urls, index)"
                      >
                        <img src="@/assets/icon/video-start.png" />
                      </div>
                    </template>
                    <template v-else>
                      <img :src="item" class="image" />
                      <div
                        class="floating"
                        @click="showPreview(other_question_urls, index)"
                      >
                        <img src="@/assets/icon/eye.png" />
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="title">
              <font>上门信息</font>
            </div>
            <div class="todoor-info">
              <div class="row">
                <font class="label">服务内容：</font>
                <div class="value">
                  <font>{{ remark || "/" }}</font>
                </div>
              </div>
              <div class="row">
                <font class="label">温馨提示：</font>
                <div class="value">
                  <font
                    >请尽快上门！上门完成后，点击下方“确认上门”按钮，通知填写售后服务单，结束本次服务！</font
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="card">
            <div class="progress-list-container">
              <progress-list
                :progress="run_process"
                :create_time="create_time"
                :process_type="process_type"
              ></progress-list>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-group" v-if="btn_group.length > 0">
        <div class="card">
          <template v-for="(item, index) in btn_group">
            <el-button
              :key="index"
              size="mini"
              :type="item.type === 'resolve' ? 'primary' : ''"
              @click="btnClickHandler(item, $route.query)"
              >{{ item.text }}</el-button
            >
          </template>
        </div>
      </div>
    </div>
    <big-preview ref="bigPreview"></big-preview>
    <dialog-approve-normal
      ref="dialogApproveNormal"
      @finish="approveFinish()"
    ></dialog-approve-normal>
  </div>
</template>
<script>
import issueService from "@/module/issue/issue.service";
import { afterSale_detail_btn } from "@/config/afterSale.config.js";
import { getEventBus } from "@/config/eventBus.config.js";
import { debounceation } from "@/utils/decorator";
import dialogApproveNormal from "@/components/afterSale/dialog-approve-normal.vue";
import bigPreview from "@/components/public/big-preview.vue";
import progressList from "@/components/public/progress-list.vue";
export default {
  components: {
    dialogApproveNormal,
    bigPreview,
    progressList,
  },
  data() {
    return {
      issueService: new issueService(),
      agency: {},
      remark: "",
      run_process: [], //流程
      create_time: "", //创建时间(经销商发起时间)
      process_type: "", //当前步骤类型
      piano_model: "", //型号
      piano_no: "", //琴号
      piano_color: "", //颜色
      piano_images: [], //琴号图片
      package_images: [], //破损外包装图
      express_images: [], //物流单据图
      musical: "", //类型
      positions: [], //问题部位
      other_question_des: "", //其他-问题描述
      other_question_urls: [], //其他-问题图片
    };
  },
  computed: {
    // 按钮组
    btn_group() {
      let btn_group = [];
      if (Number(this.$route.query.run_status) === 0) {
        btn_group =
          afterSale_detail_btn?.find((x) => x.key === this.$route.query.run_act)
            ?.btn ?? [];
      }
      return btn_group;
    },
  },
  created() {
    this.getInfo();
  },
  methods: {
    @debounceation(300)
    back() {
      this.$router.go(-1);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取信息
     */
    getInfo() {
      this.issueService
        .getVeifyQuality({
          issue_id: this.$route.query.issue_id,
          run_id: this.$route.query.run_id,
          run_process_id: this.$route.query.run_process_id,
        })
        .then((res) => {
          this.agency = res.data?.agency ?? {};
          this.remark = res.data?.content?.remark ?? "";
          this.create_time = res.data?.create_time ?? "";
          this.run_process = this.issueService.dealRunProcess(
            res.data.run_process
          );
          this.process_type = res.data?.process_type ?? "";
          this.musical = res.data?.musical ?? "";
          this.piano_model = res.data?.piano_model ?? "";
          this.piano_no = res.data?.piano_no ?? "";
          this.piano_color = res.data?.piano_color ?? "";
          this.piano_images = res.data?.piano_images
            ? res.data?.piano_images.split(",")
            : [];
          this.package_images = res.data?.package_images
            ? res.data?.package_images.split(",")
            : [];
          this.express_images = res.data?.express_images
            ? res.data?.express_images.split(",")
            : [];
          this.positions = res.data?.positions
            ? JSON.parse(res.data?.positions)
            : [];
          this.other_question_des = res.data?.other_question_des
            ? res.data?.other_question_des
            : "";
          this.other_question_urls = res.data?.other_question_urls
            ? res.data?.other_question_urls.split(",")
            : [];
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 预览
     * @param {Array} urls 地址数组
     * @param {Number} index 索引
     */
    @debounceation(300)
    showPreview(urls, index) {
      this.$refs.bigPreview.open(urls, index);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 按钮点击
     * @param {Object} item 点击的按钮数据
     * @param {Object} query 页面参数
     */
    @debounceation(300)
    btnClickHandler(item, query) {
      if (String(item.value) === "-1") {
        this.$refs.dialogApproveNormal.open({
          issue_id: query.issue_id,
          run_process_id: query.run_process_id,
          act: item.value,
          remark: "",
          ...item,
        });
      } else {
        this.$router.push({
          path: "/index/afterSale/waitDealSignServiceForm",
          query,
        });
      }
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 审核完成后调用
     */
    approveFinish() {
      this.$EventBus.$emit(getEventBus("我的售后列表发生变更"));
      this.$EventBus.$emit(getEventBus("待处理列表发生变更"));
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.waitDealToDoorService {
  width: 100%;
  height: 100%;
  .container {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 10px;
    @extend .et-flex-column-normal;
    .head {
      flex-shrink: 0;
      margin-bottom: 10px;
      @extend .et-flex-start;
    }
    .content {
      width: 100%;
      flex: 1;
      @extend .et-flex-normal;
      align-items: stretch;
      overflow-y: auto;
      padding: 5px;
      box-sizing: border-box;
      .left {
        flex: 1;
        @extend .et-flex-column-normal;
      }
      .right {
        margin-left: 10px;
        width: 330px;
        flex-shrink: 0;
        @extend .et-flex-column-normal;
      }
      .card {
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0 !important;
        }
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        border-radius: $Vars-border-radius-normal;
        box-shadow: $Vars-boxShadow-normal;
        .title {
          width: 100%;
          padding: 10px 0;
          font-size: $Vars-font-miniTitle-size;
          font-weight: bold;
          border-bottom: 1px solid $Vars-border-second-color;
        }
        .user-info {
          width: 100%;
          padding: 10px 0;
          font-size: $Vars-font-miniContent-size;
          @extend .et-flex-normal;
          .row {
            flex: 1;
            margin-left: 10px;
            &:first-child {
              margin-left: 0 !important;
            }
            @extend .et-flex-normal;
            .label {
              flex-shrink: 0;
            }
            .value {
              flex: 1;
            }
          }
        }
        .problem-info {
          width: 100%;
          padding: 10px 0;
          font-size: $Vars-font-miniContent-size;
          @extend .et-flex-column-normal;
          .piano {
            width: 100%;
            @extend .et-flex-normal;
            .col {
              flex: 1;
              line-height: $Vars-font-tight-lineHeight;
              @extend .et-flex-normal;
              font {
                &:first-child {
                  flex-shrink: 0;
                }
                &:nth-child(2) {
                  flex: 1;
                }
              }
            }
          }
          .piano_images,
          .package_images,
          .express_images,
          .other_question_des,
          .other_question_urls {
            width: 100%;
            padding: 10px 0;
            @extend .et-flex-normal;
            font {
              margin: 5px 10px 0 0;
              flex-shrink: 0;
            }
            .span {
              margin-top: 5px;
              flex: 1;
            }
            .piano_images_group,
            .package_images_group,
            .express_images_group,
            .other_question_urls_group {
              flex: 1;
              @extend .et-flex-normal;
              .img-box {
                margin: 5px;
                width: 100px;
                height: 100px;
                border-radius: $Vars-border-radius-normal;
                border: 1px solid $Vars-border-fourth-color;
                overflow: hidden;
                position: relative;
                .video-box {
                  width: 100px;
                  height: 100px;
                  background: rgb(229, 229, 229);
                  @extend .et-flex-center;
                  position: relative;
                  .video {
                    width: 100px;
                    height: 100px;
                  }
                }
                img {
                  width: 100px;
                  height: 100px;
                }
                .floating {
                  display: none;
                }
                &:hover {
                  .floating {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100px;
                    height: 100px;
                    background: rgba(0, 0, 0, 0.3);
                    z-index: 1;
                    @extend .et-clickElement;
                    @extend .et-flex-center;
                    img {
                      width: 20%;
                      height: 20%;
                    }
                  }
                }
              }
            }
          }
          .problem-detail {
            width: 100%;
            @extend .et-flex-normal;
            .problem-label {
              margin-right: 10px;
              flex-shrink: 0;
            }
            .problem-content {
              flex: 1;
              @extend .et-flex-column-normal;
              .problem-part {
                width: 100%;
                margin-bottom: 10px;
                @extend .et-flex-normal;
                .problem-name {
                  width: calc(#{$Vars-font-miniContent-size} * 8);
                  @extend .et-flex-normal;
                  flex-wrap: nowrap;
                  margin-right: 5px;
                  &::before {
                    content: "";
                    width: 4px;
                    height: 4px;
                    border-radius: 4px;
                    background: $Vars-normal-color;
                    margin-top: 6px;
                    margin-right: 10px;
                    flex-shrink: 0;
                  }
                }
                .problem-questions {
                  flex: 1;
                  @extend .et-flex-column-normal;
                  .questions-item {
                    width: 100%;
                    padding-bottom: 10px;
                    @extend .et-flex-normal;
                    .questions-head {
                      width: 100%;
                      @extend .et-flex-normal;
                      .questions-name {
                        flex: 1;
                        @extend .et-flex-normal;
                        .label {
                          flex-shrink: 0;
                        }
                        .text {
                          flex: 1;
                        }
                      }
                      .questions-desc {
                        flex: 2;
                        @extend .et-flex-normal;
                        .label {
                          flex-shrink: 0;
                        }
                        .text {
                          flex: 1;
                        }
                      }
                    }
                    .questions-images {
                      width: 100%;
                      padding: 10px 0;
                      @extend .et-flex-normal;
                      .img-box {
                        margin: 5px;
                        width: 100px;
                        height: 100px;
                        border: 1px solid $Vars-border-fourth-color;
                        border-radius: $Vars-border-radius-normal;
                        overflow: hidden;
                        position: relative;
                        .video-box {
                          width: 100px;
                          height: 100px;
                          background: rgb(229, 229, 229);
                          @extend .et-flex-center;
                          position: relative;
                          .video {
                            width: 100px;
                            height: 100px;
                          }
                        }
                        .image {
                          width: 100px;
                          height: 100px;
                        }
                        &:hover {
                          .floating {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100px;
                            height: 100px;
                            background: rgba(0, 0, 0, 0.3);
                            z-index: 1;
                            @extend .et-clickElement;
                            @extend .et-flex-center;
                            img {
                              width: 20%;
                              height: 20%;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        .todoor-info {
          width: 100%;
          padding: 10px 0;
          font-size: $Vars-font-miniContent-size;
          @extend .et-flex-column-normal;
          .row {
            width: 100%;
            margin-top: 10px;
            &:first-child {
              margin-top: 0 !important;
            }
            @extend .et-flex-normal;
            .label {
              flex-shrink: 0;
            }
            .value {
              flex: 1;
            }
          }
        }
      }
    }
    .btn-group {
      flex-shrink: 0;
      margin: 10px 0;
      width: 100%;
      .card {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        border-radius: $Vars-border-radius-normal;
        box-shadow: $Vars-boxShadow-normal;
        @extend .et-flex-center;
      }
    }
  }
}
</style>